import React, { useState } from "react";
import "./SimpleSlider.css";

export default function SimpleSlider({ images }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="Slider">
      <div className="slider-wrapper">
        <div
          className="slider-track"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {images && images.length > 0 ? (
            images.map((src, index) => (
              <div className="slide" key={index}>
                <img
                  src={src}
                  alt={`Slide ${index + 1}`}
                  className="slider-image"
                />
              </div>
            ))
          ) : (
            <div className="no-images">No images to display.</div>
          )}
        </div>
        {images && images.length > 1 && (
          <>
            <button className="arrow left" onClick={goToPrev}>
              ❮
            </button>
            <button className="arrow right" onClick={goToNext}>
              ❯
            </button>
          </>
        )}
      </div>
      <div className="dots">
        {images &&
          images.length > 0 &&
          images.map((_, i) => (
            <span
              key={i}
              className={`dot ${i === currentIndex ? "active" : ""}`}
              onClick={() => setCurrentIndex(i)}
            />
          ))}
      </div>
    </div>
  );
}
